export function UnitCtrl (
  $q,
  $state,
  $scope,
  $translate,
  $window,
  advertising,
  advertisingSettings,
  attachments,
  bodyTypes,
  company,
  companyApi,
  confirm,
  Dealership,
  driveTypes,
  franchises,
  fuelTypes,
  hullMaterialTypes,
  hullTypes,
  jsonApi,
  messages,
  salesStatusTypes,
  sessionObjAPI,
  states,
  transmissionTypes,
  unit,
  vehicleApi,
  vehicleGroups,
  workshopAPI
) {

  $scope.advertising              = advertising;
  $scope.attachments              = attachments;
  $scope.bodyTypes                = bodyTypes;
  $scope.company                  = company;
  $scope.currency                 = sessionObjAPI.currency();
  $scope.distanceLabel            = sessionObjAPI.getDistanceLabel();
  $scope.driveTypes               = driveTypes;
  $scope.franchises               = franchises;
  $scope.fuelTypes                = fuelTypes;
  $scope.hullMaterialTypes        = hullMaterialTypes;
  $scope.hullTypes                = hullTypes;
  $scope.loaded                   = true;
  $scope.regoLabel                = $scope.company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;
  $scope.salesStatusTypes         = salesStatusTypes;
  $scope.settings                 = advertisingSettings;
  $scope.states                   = states;
  $scope.transmissionTypes        = transmissionTypes;
  $scope.unit                     = unit;
  $scope.unit.originalPlateNumber = $scope.unit.plate_number;
  $scope.vehicle_body_group_types = vehicleGroups;
  $scope.vinLabel                 = $scope.company.company_variable_fields.vin_name || $translate.instant('VEHICLE_SPACE.VIN');

  $scope.attachmentOptions = {
    description: 'Vehicle attachment',
    entity     : $scope.unit,
    id_key     : 'vehicle_id',
    open       : $scope.attachments.length,
    table      : 'vehicle',
    routes     : {
      create: '/vehicle/attach_photo',
      delete: '/vehicle_attachment',
      get   : 'vehicle_attachments/for_vehicle',
      show  : 'vehicle_attachment'
    }
  };

  $scope.Company    = companyApi;
  $scope.Dealership = new Dealership({});

  $scope.calculateDaysInStock = function () {
    if ($scope.unit.sale_status == 'for_sale' || $scope.unit.sale_status == 'pending') {
      workshopAPI.get('/vehicles/days_in_stock', $scope.unit.id).then(function(days) {
        $scope.unit.days_in_stock = days;
      });
    }
    else {
      $scope.unit.days_in_stock = 'SOLD';
    };

  };

  $scope.calculateTotalCost = function () {
    $scope.unit.total_cost =
    ($scope.unit.value_of_acquisition ? parseFloat($scope.unit.value_of_acquisition) : 0) +
    ($scope.unit.internal_invoice_balance ? parseFloat($scope.unit.internal_invoice_balance) : 0);
  };

  $scope.checkPlateNumber = function () {
    if ($scope.vehicle.plate_number && $scope.vehicle.plate_number !== $scope.originalPlateNumber) {
      return workshopAPI.get('/vehicle/verify_plate_uniqueness', $scope.vehicle.plate_number)
      .then(function (unique) {
        unique = jsonApi.parse(unique);

        $scope.form.plate_number.duplicate = !unique;
        return unique;
      });
    }
    else {
      $scope.form.plate_number.duplicate = false;
      return $q.when();
    }
  };

  $scope.getVehicleGroup = function () {
    workshopAPI.get('/vehicles/find_vehicle_group_using_body_type', $scope.unit.id)
    .then(vehicle_body_type_group => {
      !$scope.unit.vehicle_group
        ? (!vehicle_body_type_group ? $scope.unit.vehicle_group = $scope.vehicle_body_group_types[0].code : $scope.unit.vehicle_group = vehicle_body_type_group)
        : $scope.unit.vehicle_group = $scope.unit.vehicle_group;

      return $scope.update_types($scope.unit.vehicle_group);
    });
  };

  $scope.delete = function() {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_UNIT'))
    .then(function () {
      return workshopAPI.delete('/vehicle', $scope.unit.id);
    }).then(function() {
      $scope.form.$setPristine();
      $state.go('app.units');
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.DELETED'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  $scope.isForSale = function () {
    return $scope.unit.sale_status === 'for_sale';
  };

  $scope.save = function (form) {
    $q.when()
    .then(() => $scope.unit.originalPlateNumber === $scope.unit.plate_number ? $q.when(true) : workshopAPI.get('/vehicle/verify_plate_uniqueness', $scope.unit.plate_number))
    .then(data => data ? $q.when(true) : confirm.generic($translate.instant('JS_SPACE.MESSAGES.VEHICLE_ALREADY_EXISTS', { label: $scope.regoLabel , rego: $scope.unit.plate_number })))
    .then(() => workshopAPI[$scope.unit.id ? 'patch': 'post']($scope.unit.id ? '/vehicle': '/vehicles', $scope.unit, 'vehicle'))
    .then(unit => {
      $scope.unit = unit;

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.UNIT'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  // send an email containing the link for the
  // unit sale page.
  $scope.sendEmail = function () {
    $scope.Dealership.sendEmail($scope.unit.id).then(function () {
      messages.show($translate.instant('GENERAL_SPACE.MESSAGE.EMAIL_SENT'), 'success');
    }, function (error) {
      messages.error(error);
    });
  };

  // send an sms containing the link for the
  // unit sale page.
  $scope.sendSMS = function () {
    $scope.Dealership.sendSMS($scope.unit.id).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    }, function (error) {
      messages.error(error);
    });
  };

  //print dealership vehicle forms
  $scope.printVehicleForm = function() {
    if (!$scope.unit.id) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MUST_SAVE_VEHICLE_BEFORE_PRINTING'), 'warning');
      return;
    }

    vehicleApi.printVehicleForm($scope.unit);
  };

  // user updated the unit suggested sale
  // price including tax, so update the price
  // excluding tax.
  $scope.updatePriceExcludingTax = function () {
    $scope.unit.suggested_sale_price =
    vehicleApi.calculatePriceExcludingTax($scope.unit.suggested_sale_price_including_tax);
  };

  // user updated the unit suggested sale
  // price excluding tax, so update the price
  // including tax.
  $scope.updatePriceIncludingTax = function () {
    $scope.unit.suggested_sale_price_including_tax =
    vehicleApi.calculatePriceIncludingTax($scope.unit.suggested_sale_price);
  };

  $scope.update_types = function(group) {
    return group
      ? workshopAPI.get('/system/vehicle_body_types_limited', group)
      .then(bodyTypes => {
        $scope.bodyTypesLimited = bodyTypes;
      })
      : $q.when();
  };

  // user updated the unit value of
  // acquisition including tax, so update
  // the value excluding tax.
  $scope.updateValueExcludingTax = function () {
    $scope.unit.value_of_acquisition =
    vehicleApi.calculatePriceExcludingTax($scope.unit.value_of_acquisition_including_tax);
  };

  // user updated the unit value of
  // acquisition excluding tax, so update
  // the value including tax.
  $scope.updateValueIncludingTax = function () {
    $scope.unit.value_of_acquisition_including_tax =
    vehicleApi.calculatePriceIncludingTax($scope.unit.value_of_acquisition);
  };

  // opens the unit standalone page in a
  // new window.
  $scope.viewStandalonePage = function () {
    $window.open(`${sessionObjAPI.base().origin}vehicle.html#/vehicle/${$scope.unit.id}`, '_blank');
  };

  $scope.calculateTotalCost();
  $scope.calculateDaysInStock();
  $scope.getVehicleGroup();
  $scope.update_types($scope.unit.vehicle_group);

  if ($scope.unit.vehicle_group) {
    $scope.group = $scope.unit.vehicle_group;
  }
  else {
    $scope.group = vehicleGroups.length > 0 || !$scope.unit.id
    ? vehicleGroups[0].code
    : '*';
  };
}